import { showError } from './errorHandler';
import { appendPlanAccessHeader, setPlanAccessCode } from './utils/planAccess';

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
let accessToken = localStorage.getItem('token');
let refreshToken = localStorage.getItem('refreshToken');
let authErrorHandler = null;

export function setAuthErrorHandler(fn) {
  authErrorHandler = fn;
}

export function setTokens({ token, refreshToken: newRefresh }) {
  accessToken = token;
  refreshToken = newRefresh;
  localStorage.setItem('token', token);
  localStorage.setItem('refreshToken', newRefresh);
}

export function logout() {
  accessToken = null;
  refreshToken = null;
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  if (authErrorHandler) authErrorHandler();
}

async function refresh() {
  if (!refreshToken) return false;
  const res = await fetch(API_BASE_URL + '/refresh', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken })
  });
  if (!res.ok) {
    logout();
    return false;
  }
  const data = await res.json();
  setTokens(data);
  return true;
}

export async function apiFetch(url, options = {}, retry = true) {
  options.headers = options.headers || {};
  if (accessToken) options.headers['Authorization'] = 'Bearer ' + accessToken;
  if (options.planUuid) {
    appendPlanAccessHeader(options.headers, options.planUuid);
  }
  const finalUrl = url.startsWith('http') ? url : API_BASE_URL + url;
  try {
    const res = await fetch(finalUrl, options);
    if (options.planUuid && res.ok) {
      const issuedCode = res.headers.get('X-Plan-Access-Code');
      if (issuedCode) {
        setPlanAccessCode(options.planUuid, issuedCode);
      }
    }
    if (res.status === 401 && retry) {
      const ok = await refresh();
      if (ok) {
        return apiFetch(url, options, false);
      } else {
        throw new Error('Unauthorized');
      }
    }
    const isShare = typeof url === 'string' && url.startsWith('/share/');
    if (!res.ok && !url.endsWith('/status') && !url.endsWith('/stream') && !options.silent) {
      let message = '';
      try {
        message = (await res.json()).message || res.statusText;
      } catch {
        message = res.statusText;
      }
      if (isShare) {
        console.error(message);
      } else {
        showError(message);
      }
    }
    return res;
  } catch (e) {
    const isShare = typeof url === 'string' && url.startsWith('/share/');
    if (!url.endsWith('/status') && !url.endsWith('/stream') && !options.silent) {
      if (isShare) {
        console.error(e);
      } else {
        showError(e);
      }
    }
    throw e;
  }
}

export async function createPayment(planUuid, amount, { purchaseType = 'PLAN', quantity = 1 } = {}) {
  const res = await apiFetch('/payments', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ planUuid, amount, purchaseType, quantity })
  });
  if (!res.ok) throw new Error('Payment failed');
  return res.json();
}

export async function confirmPayment(paymentId) {
  if (!paymentId) return { confirmed: false, status: 'unknown' };
  const res = await apiFetch(`/payments/${encodeURIComponent(paymentId)}/confirm`, {
    method: 'POST',
    silent: true,
  });
  if (!res.ok) return { confirmed: false, status: 'unknown' };
  return res.json();
}

export async function pingVisitor(visitorId) {
  const res = await apiFetch('/visitor/ping', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ visitorId }),
    silent: true,
  });
  return res.ok ? res.json() : null;
}
